'use es6';

import { createContext } from 'react';
export const FloatingButtonGroupContext = /*#__PURE__*/createContext({
  setFloatingButtonGroupActiveEl: null
});
export const {
  Provider: FloatingButtonGroupContextProvider
} = FloatingButtonGroupContext;